<div
	class="slide slide--website-traffic-demographics"
	[style.--slide-accent-color]="titleColor"
>
	<div class="slide__header">
		<div class="slide__content-copy">
			<typography variant="h/2" class="slide__title">
				<app-report-inline-text
					[text]="title"
					[field]="textFields.title"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
			<div class="slide__date-row">
				<app-icon type="svg" [size]="14">calendar_today</app-icon>
				<typography variant="p/xs_regular" class="slide__date-text">
					{{ dateLabel }}
				</typography>
			</div>
			<typography variant="p/sm_regular" class="slide__summary">
				<app-report-inline-text
					[text]="summaryText"
					[field]="textFields.body"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
		</div>

		<div class="slide__kpi" *ngIf="!isEmpty">
			<typography variant="h/1" class="slide__kpi-value">
				{{ kpiValue }}
			</typography>
			<div class="slide__kpi-label-row">
				<span class="slide__kpi-dot"></span>
				<typography variant="p/sm_regular" class="slide__kpi-label">
					{{ kpiLabel }}
				</typography>
			</div>
		</div>
	</div>

	<div class="slide__body" *ngIf="!isEmpty">
		<div class="slide__panel slide__panel--donut">
			<div class="slide__donut">
				<canvas
					baseChart
					[data]="donutChartData"
					[options]="donutChartOptions"
					[type]="donutChartType"
				></canvas>
			</div>
		</div>

		<div class="slide__panel slide__panel--table">
			<typography variant="p/base_medium" class="slide__panel-title">
				Audience profile
			</typography>
			<div class="slide__table">
				<div class="slide__row slide__row--head">
					<span class="slide__cell slide__cell--group">
						Age group
					</span>
					<span class="slide__cell slide__cell--num">Sessions</span>
					<span class="slide__cell slide__cell--num">Avg. time</span>
					<span class="slide__cell slide__cell--num">Bounce</span>
				</div>
				<div
					class="slide__row"
					*ngFor="let row of ageRows; trackBy: trackAgeRow"
				>
					<span class="slide__cell slide__cell--group">
						<span
							class="slide__group-dot"
							[style.background]="row.color"
						></span>
						<span class="slide__group-label">{{ row.label }}</span>
					</span>
					<span class="slide__cell slide__cell--num">
						{{ row.sessions }}
					</span>
					<span class="slide__cell slide__cell--num">
						{{ row.avgTime }}
					</span>
					<span class="slide__cell slide__cell--num">
						{{ row.bounce }}
					</span>
				</div>
			</div>
		</div>
	</div>

	<app-slide-no-data *ngIf="isEmpty"></app-slide-no-data>

	<div class="slide__footer">
		<app-report-slide-brand class="slide__footer-left">
			<typography variant="p/xxs_regular" class="slide__footer-copy">
				Powered by
			</typography>
			<typography variant="p/xxs_semibold" class="slide__footer-brand">
				lolly
			</typography>
		</app-report-slide-brand>
		<div class="slide__footer-tag">website demographics</div>
	</div>
</div>
